import EmbedMessage from './EmbedMessage';
export default EmbedMessage;

export const componentName = 'EmbedMessage';
